import { AST } from '@handlebars/parser';
import { StatementSerializer } from '../statement/serializer';

export class ProgramSerializer {
  static serialize = (program: AST.Program) => {
    return StatementSerializer.serializeAll(program.body);
  };
}
